module.exports = __webpack_public_path__ + "img/88.5e0e8536.png";